import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';

const Send_history_monthly = () => {

    const today = new Date();
    const currentYear = today.getFullYear();
    let currentMonth = today.getMonth() + 1;
    if (currentMonth < 10) {
        currentMonth = "0" + currentMonth;
    }

    const [searchParams, setSearchParams] = useState({
        searchYear: currentYear,
        searchMonth: currentMonth,
        searchEmog: localStorage.getItem("userAuth") === 'J003' ? localStorage.getItem("useremcd") : '',
        searchGrdc: localStorage.getItem("userAuth") === 'J003' ? localStorage.getItem("emoggrdc2") : '',
        searchLoca: localStorage.getItem("userAuth") === 'J003' ? localStorage.getItem("emogloca") : '',
        fromindt: String(currentYear) + currentMonth + '01',
        toindt: String(currentYear) + currentMonth + '31',
        validationCheckList: ['searchEmog']
    });

    const searchParamsAdditional = {
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        if (name === 'searchYear' || name === 'searchMonth') {
            const year = name === 'searchYear' ? value : searchParams.searchYear;
            const month = name === 'searchMonth' ? value : searchParams.searchMonth;

            const paddedMonth = String(month).padStart(2, '0');

            const fromindt = `${year}${paddedMonth}01`;
            const toindt = `${year}${paddedMonth}31`;

            newParams.fromindt = fromindt;
            newParams.toindt = toindt;

            setSearchParams(newParams);
        }
        setSearchParams(newParams);
    };

    const dataHead = ['기관명', '내원일자', '전송건수']; //component화 
    const dataColumn = ['PTMIEMCD', 'PTMIINDT', 'CNT'];
    const apiCall = '/ptmiapi/fidelity_data_cnt.do';
    const apiCntCall = '';
    const excelFileName = '월별전송건수내역';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead,
        colWidth: ['40%', '35%', '25%']
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="6%" />
                        <col width="20%" />
                        <col width="6%" />
                        <col width="20%" />
                        <col width="6%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>내원기간</th>
                            <td colSpan={5}>
                                <select id="searchYear"
                                    name="searchYear"
                                    value={searchParams.searchYear}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 10 }, (_, i) => {
                                        const year = (currentYear - i).toString()
                                        return (
                                            <option key={year} value={year}>
                                                {year} 년
                                            </option>
                                        );
                                    })}
                                </select>
                                &ensp;
                                <select id="searchMonth"
                                    name="searchMonth"
                                    value={searchParams.searchMonth}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 12 }, (_, i) => {
                                        const month = (i + 1).toString().padStart(2, '0');
                                        return (
                                            <option key={month} value={month}>
                                                {month} 월
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
        </Main>
    )
}

export default Send_history_monthly;